export const Gradient = ({ color = '#978CF9' }: { color?: string }) => {
  return (
    <svg
      className="gradient"
      xmlns="http://www.w3.org/2000/svg"
      width="191"
      height="209"
      viewBox="0 0 191 209"
      fill="none"
    >
      <g opacity="0.5" filter="url(#filter0_f_9337_216820)">
        <ellipse cx="95.3022" cy="104.24" rx="46.8022" ry="56" fill={color} />
      </g>
      <defs>
        <filter
          id="filter0_f_9337_216820"
          x="0.5"
          y="0.240234"
          width="189.604"
          height="208"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="24"
            result="effect1_foregroundBlur_9337_216820"
          />
        </filter>
      </defs>
    </svg>
  );
};
